<template>
  <div class="mb-10">
    <b-row class="mt-10">
      <b-col>
        <puls-form-input
          v-model="searchQuery"
          :placeholder="$t('home.search.placeholder')"
          type="search"
          autocomplete="off"
        >
        </puls-form-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <SearchResults
          :articleData="articleData"
          :searchQuery="searchQuery"
          :fuseIndex="fuseIndex"
          :fuseOptions="fuseOptions"
          v-if="searchQuery.length"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import en from '../locales/en'
import Fuse from 'fuse.js'
import SearchResults from './SearchResults'

export default {
  name: 'Search',
  components: { SearchResults },
  props: {},
  data: () => {
    return {
      searchQuery: '',
      fuseIndex: null,
      articleData: Array,
      fuseOptions: {
        includeScore: true,
        useExtendedSearch: true,
        threshold: 0.6,
        distance: 10,
        // ignoreLocation: true,
        keys: ['title', 'body', 'meta'],
        findAllMatches: true
      }
    }
  },
  mounted() {
    // Create the Fuse index
    const data = Object.keys(en.home.sections)
      .map((key) => {
        return { section: key, articles: en.home.sections[key].articles }
      })
      .reduce((res, item) => {
        const articles = Object.keys(item.articles).map((key) => ({
          article: key,
          section: item.section,
          ...item.articles[key]
        }))
        res = res.concat(articles)
        return res
      }, [])
      .map((article) => {
        return {
          ...article,
          ...this.fuseOptions.keys.reduce((r, k) => {
            r[k] = this.$t(
              `home.sections.${article.section}.articles.${article.article}.${k}`
            )
            return r
          }, {})
        }
      })

    this.articleData = data
    this.fuseIndex = Fuse.createIndex(this.fuseOptions.keys, data)
  },
  computed: {}
}
</script>

<style scoped></style>
